import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=15a010d1&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=15a010d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a010d1",
  null
  
)

export default component.exports